
// ======================= product video js

new Swiper('.product_video_blocks', {
    loop: true,
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
        1200: {
            slidesPerView: 3,
        },
        576: {
            slidesPerView: 3,
        },
        480: {
            slidesPerView: 3,
        }
    }
});

function toggleMute(btn) {
const video = btn.closest(".product_video_inner").querySelector("video");
const mutedIcon = btn.querySelector(".muted_icon");
const unmutedIcon = btn.querySelector(".unmuted_icon");

if (video.muted) {
    video.muted = false;
    mutedIcon.style.display = "none";
    unmutedIcon.style.display = "block";
} else {
    video.muted = true;
    mutedIcon.style.display = "block";
    unmutedIcon.style.display = "none";
}
}

document.addEventListener('DOMContentLoaded', () => {

  function keepVideosPlaying() {
    document.querySelectorAll('.product_video_inner video').forEach(video => {
      if (video.paused) {
        video.play().catch(() => {
          video.muted = true; // fallback for browsers that block autoplay
          video.play();
        });
      }
    });
  }

  // Initial autoplay on page load
  keepVideosPlaying();

  // Listen for variant changes or any Shopify events
  document.addEventListener('variant:change', keepVideosPlaying);
  document.addEventListener('product:updated', keepVideosPlaying);

  // Use MutationObserver to catch DOM changes that might pause videos
  const observer = new MutationObserver(keepVideosPlaying);
  observer.observe(document.body, { childList: true, subtree: true });

  // Optional: check every 1 second to ensure videos are playing
  setInterval(keepVideosPlaying, 1000);
});